<template>
    <div class="row">
        <div class="col-xs-12 text-xs-left">
            <h3 class="modal__title">{{ $t('DO_YOU_WANT_TO_DEACTIVATE') }}</h3>
            <br />
            <br />
            <ul>
                <li>
                    {{ $t('DEACTIVATE_1') }}
                </li>
                <li>
                    {{ $t('DEACTIVATE_2') }}
                </li>
                <li>
                    {{ $t('DEACTIVATE_3') }}
                </li>
            </ul>
            <br />
            <br />

            <div class="text-center">
                <button
                    class="app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg"
                    @click="$emit('close')"
                >
                    {{ $t('CANCEL') }}
                </button>
                <button class="app-btn app-btn--big app-btn-primary" @click="deactivateAccount">
                    {{ $t('DEACTIVATE_ACCOUNT') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { logoutUser } from '../../main';

export default {
    methods: {
        deactivateAccount() {
            this.$http.patch('/user/api/profile/user/block').then(logoutUser);
        },
    },
};
</script>



// WEBPACK FOOTER //
// deactivate-account.vue?0a046e87